import React from "react";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05 } },
};

const child = {
  hidden: { opacity: 0, y: 14, filter: "blur(6px)" },
  show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function StaggerText({ text, className = "", as: As = "h1", testId }) {
  const words = text.split(" ");
  return (
    <motion.div initial="hidden" animate="show" variants={container} data-testid={testId}>
      <As className={className}>
        {words.map((w, i) => (
          <motion.span key={i} variants={child} className="inline-block mr-[0.25em]">{w}</motion.span>
        ))}
      </As>
    </motion.div>
  );
}
